import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import i18n from '../i18n/i18n';
import '../styles/theme.css';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Catches render errors so a blank screen is replaced with a recoverable message.
 */
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('UI error:', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="form-step-page" role="alert">
          <div className="form-step-card" style={{ maxWidth: 480, margin: '2rem auto' }}>
            <h1 className="form-step-title" style={{ fontSize: '1.25rem' }}>
              {i18n.t('errorBoundary.title')}
            </h1>
            <p className="form-step-body" style={{ marginTop: '0.75rem' }}>
              {i18n.t('errorBoundary.message')}
            </p>
            <button
              type="button"
              className="form-step-next"
              style={{ marginTop: '1.25rem' }}
              onClick={() => {
                this.setState({ hasError: false });
                window.location.assign('/');
              }}
            >
              {i18n.t('errorBoundary.returnHome')}
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
